<script lang="ts">  
    // packages
    import { descending } from 'd3-array';

    import Bars from './Bars.svelte';

    /** @type {import('../types.d').ReadableRace} */
    export let feed;
  
    /** @type {boolean} */
    export let face;

    /** @type {number} */
    export let numOfCandidates;
  
    /** @type {import('../types.d').Crosswalk} */
    export let crosswalk;

    $: race = feed;
    
    // Electors to win does not exist in this dataset
    // $: electorsToWin = $race.electors_to_win;
    let electorsToWin = 270;
    
    // Sort and slice to the number of candidates that we want to show
    $: sortedCandidates = $race.candidates;
    $: if ($race.total_votes == 0) {
        sortedCandidates = $race.candidates.filter(d => d.family_name == "Harris" || d.family_name == "Trump")
    } else {
        sortedCandidates = $race.candidates.sort((a, b) => descending(a.votes, b.votes)).slice(0, numOfCandidates)
    }

</script>

<div class="candidate-big-bars position-relative text-sans-serif space-y-n2">
    <!-- Add winner key and adjust top margin -->
    {#each sortedCandidates as candidate, idx (candidate.ap_id)}
    <Bars 
        familyName={candidate.family_name}
        givenName={candidate.given_name}
        party={candidate.party}
        isWinner={candidate.is_winner}
        votes={candidate.votes}
        electorsWon={candidate.electors_won}
        totalVotes={$race.total_votes}
        totalElectors={$race.electors_total}
        idx={idx}
        barFace={face}
        lookup={face?crosswalk[candidate.ap_id]:''} />
    {/each}
    <div class="balance-bar-container w-full h-full position-absolute top-0 left-0">
        <p class="text-center text-bold balance-bar-text">50% + 1 vote</p>
        <div class="balance-bar" />
    </div>
</div>